<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">آخرین اخبار فرمن</h1>
          <div class="my-2" v-if="latestNewsDetails">
            <small>محتوای خبر</small>
            <!-- <quillEditor
              v-model="latestNewsDetails.pageContent"
              class="mt-1"
              :options="editorOption"
            /> -->

            <label class="d-inline d-lg-none">Description</label>
            <b-form-textarea
              v-model="latestNewsDetails.pageContent"
              class="mt-1 mb-lg-0"
            />
          </div>
          <div class="w-100 d-flex align-items-center justify-content-end">
            <b-button variant="primary" @click="updateAPage"
              >بروزرسانی</b-button
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>
export default {
  mounted() {
    this.getPageById();
  },
  data() {
    return {
      isLoading: false,
      latestNewsDetails: null,

      editorOption: {
        // Some Quill options...
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ["clean"],
            ["link", "image", "video"],
          ],
        },
      },
    };
  },
  methods: {
    async updateAPage() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateADynamicPage = new UpdateADynamicPage(_this);
        updateADynamicPage.setRequestParamDataObj(_this.latestNewsDetails);
        await updateADynamicPage.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "آخرین اخبار با موفقیت آپدیت شد",
                icon: "EditIcon",
                variant: "success",
              },
            });
            _this.getPageById();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getPageById() {
      try {
        this.isLoading = true;
        let _this = this;
        let getPageById = new GetPageById(_this);
        getPageById.setRequestParam({
          id: _this.$route.params.id,
        });
        await getPageById.fetch((response) => {
          if (response.isSuccess) {
            _this.latestNewsDetails = response.data;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormTextarea,
    BButton,
    BOverlay,
    vSelect,
    quillEditor,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import {
  GetPageBySeoUrl,
  GetPageById,
  UpdateADynamicPage,
} from "@/libs/Api/DynamicPages";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import {
  BCard,
  BRow,
  BCol,
  BFormTextarea,
  BButton,
  BOverlay,
} from "bootstrap-vue";
</script>
